import { IIconProps, IIconSize } from "src/components/icons/IconProps";
const SvgPieChart = (props: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    height={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.21 15.89A10 10 0 1 1 8 2.83"
    />
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22 12A10 10 0 0 0 12 2v10z"
    />
  </svg>
);
export default SvgPieChart;
